import type {
    ChangeProductQuantityInCartMutationVariables,
    ChangeProductSizeInCartMutationVariables,
    ChangeProductSizeToExistOneInCartMutationVariables,
    EccoAddProductToCartMutationVariables,
    EccoRemoveProductFromCartMutationVariables,
} from "@graphql/generated/types";

import { updateMutation } from "../helpers";
import { useStore } from "../store";
import { useCommerceClient } from "@graphql/useCommerceClient";

export const useAddProductToCart = () => {
    const { client } = useCommerceClient();
    const executeWithVariables = client.eccoAddProductToCart;
    const setData = useStore((state) => state.setCart);
    return updateMutation<EccoAddProductToCartMutationVariables>(executeWithVariables, setData);
};

export const useRemoveProductFromCart = () => {
    const { client } = useCommerceClient();
    const executeWithVariables = client.eccoRemoveProductFromCart;
    const setData = useStore((state) => state.setCart);
    return updateMutation<EccoRemoveProductFromCartMutationVariables>(
        executeWithVariables,
        setData
    );
};

export const useUpdateProductQtyInCart = () => {
    const { client } = useCommerceClient();
    const executeWithVariables = client.changeProductQuantityInCart;
    const setData = useStore((state) => state.setCart);
    return updateMutation<ChangeProductQuantityInCartMutationVariables>(
        executeWithVariables,
        setData
    );
};

export const useUpdateProductSizeInCart = () => {
    const { client } = useCommerceClient();
    const executeWithVariables = client.changeProductSizeInCart;
    const setData = useStore((state) => state.setCart);
    return updateMutation<ChangeProductSizeInCartMutationVariables>(executeWithVariables, setData);
};

export const useUpdateProductSizeToExistOneInCart = () => {
    const { client } = useCommerceClient();
    const executeWithVariables = client.changeProductSizeToExistOneInCart;
    const setData = useStore((state) => state.setCart);
    return updateMutation<ChangeProductSizeToExistOneInCartMutationVariables>(
        executeWithVariables,
        setData
    );
};
